import { createSelector } from "reselect";

const pendingPublicInquiryStateSelector = (state) =>
  state.pendingArtisansPublicInquiry;
  
const selectById = (state, itemId) => itemId;

export const pendingArtisansPublicInquirySelector = createSelector(
  [pendingPublicInquiryStateSelector],
  (publicInquiry) => publicInquiry.items
);

export const publicInquiryByIdSelector = createSelector(
  [pendingArtisansPublicInquirySelector, selectById],
  (publicInquiries, _id) => {
    const publicInquiry = publicInquiries.find((item) => _id === item._id);
    if (!publicInquiry) return null;
    return publicInquiry;
  }
);

export const pendingArtisansPublicInquiryAsListSelector = createSelector(
  [pendingArtisansPublicInquirySelector],
  (publicInquiries) =>
    publicInquiries.map((publicInquiry) => ({

      _id: publicInquiry.inquiryID,
      message: publicInquiry.message,
      title: publicInquiry.title,
    }))
);

export const pendingArtisansPublicInquiryIsLoadingSelector = createSelector(
  [pendingPublicInquiryStateSelector],
  (publicInquiry) => publicInquiry.isLoading
);

export const pendingArtisansPublicInquiryCountSelector = createSelector(
  [pendingPublicInquiryStateSelector],
  (publicInquiry) => publicInquiry.count
);


export const pendingArtisanPublicInquiryByIdSelector = createSelector(
  [pendingArtisansPublicInquirySelector, selectById],
  (artisans, _id) => {
    const pendingArtisan = artisans.find((item) => _id === item._id);
    console.log( pendingArtisan, _id)
    if (!pendingArtisan) return null;
    return pendingArtisan;
  }
);